import Vue from 'vue'
import Router from 'vue-router'
import Live from '@/views/Live'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/live/',
      name: 'live-stream',
      component: Live
    },
    {
      path: '/embed/live/',
      name: 'embed-live',
      component: Live
    },
    {
      path: '/video/',
      name: 'video',
      component: Live
    },
    {
      path: '/live/:slug',
      name: 'live',
      component: Live
    },
    {
      path: '/media/videos/:slug',
      name: 'media',
      component: Live
    },
    {
      path: '/media/video/:slug',
      name: 'media-2',
      component: Live
    }
  ]
})
